export const AUTH_BASE_URL = '/user';
